import { EmptyDataAreaInfoBox } from '@upright/ui/common/upright/core/impact-lens-profile/common/components/info-boxes/empty-data-area-info-box';
import { Side } from '@upright/ui/common/upright/core/impact-lens-profile/common/layout/types';
import { PaiLegend } from '@upright/ui/common/upright/core/impact-lenses/pais/info-boxes/empty-data-area/legend';
import styled from 'styled-components';

export function EmptyPaiDataArea() {
  const inner = (
    <div>
      <Text>
        The Principal Adverse Impact indicators of the EU SFDR regulation only cover negative (adverse) impacts.
      </Text>
      <PaiLegend style={{ marginTop: '2.5em' }} />
    </div>
  );
  return <EmptyDataAreaInfoBox side={Side.RIGHT} text={inner} />;
}

const Text = styled.div`
  line-height: 1.4;
  max-width: 250px;
  margin-left: auto;
  margin-right: auto;
`;
